import React, { useEffect, useRef, useState } from 'react';

import { userAuth } from '../../../../network/apis/apiUri';
import { errorAlert, i10nAlert } from '../../../../util';

export default function GoogleAuthn({ option, handleClose }) {
  const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENTID;
  const googleRef = useRef();

  const [tokenId, setTokenId] = useState(null);

  useEffect(() => {
    if (tokenId) {
      const isFirst = option.exist === 'no';
      if (isFirst) {
        const checkNick = option.nick.trim() === '';

        if (checkNick) {
          return i10nAlert('insert_nick');
        }

        userAuth({
          action_type: 'regi',
          auth_type: 'google',
          token: tokenId,
          nick_name: option.nick,
        })
          .then((res) => {
            if (res.status === 200) {
              localStorage.setItem(
                'userData',
                JSON.stringify({
                  token: res.data.resultCode.access_token,
                  nickName: res.data.nick_name,
                })
              );
              handleClose();
            }
          })
          .catch(errorAlert);
      }
      if (!isFirst) {
        userAuth({
          action_type: 'both',
          auth_type: 'google',
          token: tokenId,
        })
          .then((res) => {
            if (res.status === 200) {
              localStorage.setItem(
                'userData',
                JSON.stringify({
                  token: res.data.resultCode.access_token,
                  nickName: res.data.nick_name,
                })
              );
              handleClose();
            }
          })
          .catch(errorAlert);
      }
    }
  }, [tokenId]);

  const googleCallBack = (data) => {
    setTokenId(data.credential);
  };
  useEffect(() => {
    if (tokenId) {
    }
  }, [tokenId]);

  useEffect(() => {
    window.google.accounts.id.initialize({
      client_id: CLIENT_ID,
      callback: googleCallBack,
      ux_mode: 'popup',
    });

    window.google.accounts.id.renderButton(googleRef.current, {
      theme: 'outline',
      size: 'large',
    });
  }, []);

  return <div ref={googleRef} />;
}
